import { Select } from "@chakra-ui/react";

interface SelectOption {
  label: string;
  value: any;
}

interface SelectFilterProps {
  options: SelectOption[];
  onFilterChange: (event: any) => void;
}

export const SimpleSelectFilter = ({
  options,
  onFilterChange,
}: SelectFilterProps) => {
  return (
    <Select
      my="8px"
      placeholder="Filter"
      id="status"
      border="1px solid rgba(0, 0, 0, 0.14) !important"
      color="#54565A"
      onChange={onFilterChange}
    >
      {options.map((option: SelectOption) => (
        <option
          value={option.value}
          style={{ background: "white", color: "#54565A" }}
        >
          {option.label}
        </option>
      ))}
    </Select>
  );
};
